import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (e2) { setError(formatApiError(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="New Password" subtitle="Choose a new password">
      {!token ? (
        <div className="bg-red-50 text-red-600 p-4 rounded-lg">Invalid or missing reset link.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg">{error}</div>}
          <div>
            <label className="text-sm font-semibold text-slate-700">New Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password"
              className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" />
          </div>
          <button disabled={busy} data-testid="reset-submit"
            className="w-full bg-[#0a1420] text-white font-bold py-3 rounded-lg hover:bg-[#22d3ee] hover:text-[#0a1420] transition-colors disabled:opacity-60">
            {busy ? "Updating…" : "Update Password"}
          </button>
        </form>
      )}
      <p className="text-center text-sm text-slate-500 mt-6"><Link to="/login" className="text-[#06b6d4] font-semibold hover:underline">Back to sign in</Link></p>
    </AuthShell>
  );
}
